export const PERSONAL_PLAN_TAKE_ITEMS = 30;
export const PERSONAL_PLAN_MSW_KEY = 'PERSONAL_PLAN_MSW_KEY';
export const PERSONAL_PLAN_KEY = 'PERSONAL_PLAN_KEY';
